import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import PlaygroundForm from './PlaygroundForm';
import { Container } from '@mui/material';

const fieldArrayValues = [
  'hello',
  'hi',
  'how are you?',
];

function Playground() {
  const form = useForm({
    values: {
      myCustomField: 'customValue',
      myCustomFieldArray: fieldArrayValues,
    },
  });

  const handleSubmit = () => {};

  return (
    <FormProvider {...form}>
      <Container maxWidth="xl" sx={{ mt: 5 }}>
        <PlaygroundForm onSubmit={form.handleSubmit(handleSubmit)}/>
      </Container>
    </FormProvider>
  );
}

export default Playground;
